import { render, staticRenderFns } from "./SubmissionAdd.vue?vue&type=template&id=4ba4ca33"
import script from "./SubmissionAdd.vue?vue&type=script&lang=js"
export * from "./SubmissionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports